export default __webpack_public_path__ + "static/media/lady.f3b5ac3d.png";